module.exports = __webpack_public_path__ + "media/images/referral2-9f37f089.png";